import styled from "@emotion/styled";

const ProductsGrid = styled.div<{
  hideCategoryTree?: boolean;
  isNewGrid?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: -16px;

  & > * {
    flex: 1 0 0;
    width: 30%;
    margin-top: 16px;
  }

  @supports (display: grid) {
    margin-top: 0;
    display: grid;
    grid-template-columns: ${({ hideCategoryTree }) =>
      hideCategoryTree ? "repeat(4, 1fr)" : "repeat(3, 1fr)"};
    grid-gap: 32px;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints?.md}) {
      ${({ isNewGrid }) => (isNewGrid ? "grid-column: span 3;" : "")}
    }

    & > * {
      width: auto;
      margin-top: 0;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    grid-gap: 24px;
    grid-template-columns: ${({ hideCategoryTree }) =>
      hideCategoryTree ? "repeat(4, 1fr)" : "repeat(3, 1fr)"};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.sm}) {
    grid-template-columns: repeat(auto-fill, minmax(136px, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.xs}) {
    grid-gap: 8px;
  }
`;

export default ProductsGrid;
